import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-wfq",
  "use": "icon-wfq-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-wfq\"><defs><style type=\"text/css\"></style></defs><path d=\"M351.1 934.7h-272v-832h800v416h-64v-352h-672v704h208z\" p-id=\"4684\" /><path d=\"M271.1 326.7h416v64h-416zM272 502.7h224v64H272zM849.8 634.9l135.8 135.7-135.8 135.8-45.2-45.3 90.5-90.5-90.5-90.5z\" p-id=\"4685\" /><path d=\"M495.1 742.7h416v64h-416z\" p-id=\"4686\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol